// src/services/notificationService.js
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { doc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import app, { db } from "./firebase";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

let messagingInstance = null;

function getMessagingInstance() {
  if (!messagingInstance) {
    messagingInstance = getMessaging(app);
  }
  return messagingInstance;
}

// Request notification permission and get FCM token
export async function requestNotificationPermission(uid) {
  if (!("Notification" in window)) return { ok: false, reason: "unsupported" };
  if (!VAPID_KEY) return { ok: false, reason: "no-vapid-key" };

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { ok: false, reason: "denied" };

  try {
    const messaging = getMessagingInstance();
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token) {
      await saveFCMToken(uid, token);
      return { ok: true, token };
    }
    return { ok: false, reason: "no-token" };
  } catch (err) {
    console.warn("FCM token error:", err.message);
    return { ok: false, reason: err.message };
  }
}

export async function removeFCMToken(uid, token) {
  if (!uid || !token) return;
  const ref = doc(db, "users", uid);
  await updateDoc(ref, { fcmTokens: arrayRemove(token) });
}

async function saveFCMToken(uid, token) {
  const ref = doc(db, "users", uid);
  await updateDoc(ref, { fcmTokens: arrayUnion(token) });
}

// Listen for foreground notifications (app is open)
export function onForegroundMessage(callback) {
  try {
    const messaging = getMessagingInstance();
    return onMessage(messaging, callback);
  } catch {
    return () => {};
  }
}

export function notificationsSupported() {
  return "Notification" in window && "serviceWorker" in navigator && !!VAPID_KEY;
}

export function notificationsEnabled() {
  return Notification.permission === "granted";
}
